type ReportPdfExportBody = {
  skipLiveCoverMap: true;
  coverMapDataUrl?: string;
  /** Baseline the user is viewing. Omitted so the server can use the active version. */
  versionId?: string;
  /** Footer organization label replayed on the print URL. */
  organizationName?: string;
};

type BuildReportPdfExportBodyOptions = {
  versionId?: string;
  organizationName?: string;
  coverMapDataUrl?: string;
};

/**
 * JSON body for `POST projects/:id/pdf`.
 * Sends the open baseline and the footer organization label.
 * Blank values are omitted.
 */
export const buildReportPdfExportBody = ({
  versionId,
  organizationName,
  coverMapDataUrl,
}: BuildReportPdfExportBodyOptions): ReportPdfExportBody => ({
  skipLiveCoverMap: true,
  ...(coverMapDataUrl ? { coverMapDataUrl } : {}),
  ...(versionId ? { versionId } : {}),
  ...(organizationName ? { organizationName } : {}),
});
